import React, { useEffect } from 'react';
import { Grid, TextField, Typography, Paper, MenuItem } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { useFormValidation } from './useFormValidation';

/* =======================
    STEP 1 — Información General
   ======================= */
function DatosGenerales({ state, onChange, solicitud }) {
    const { safeValue, safeError, conError } = useFormValidation(state);
    const theme = useTheme();

    useEffect(() => {

            if (solicitud?.usuario_registro) {
    
                const usuario = solicitud.usuario_registro;
    
                const nombreCompleto = `
                    ${usuario.primer_nombre || ''} 
                    ${usuario.segundo_nombre || ''} 
                    ${usuario.primer_apellido || ''} 
                    ${usuario.segundo_apellido || ''}
                `.replace(/\s+/g, ' ').trim();

                onChange({
                    target: {
                        name: 'nombre_completo',
                        value: nombreCompleto
                    }
                });
    
                onChange({
                    target: {
                        name: 'documento_identidad',
                        value: usuario.identificacion || ''
                    }
                });
    
                onChange({
                    target: {
                        name: 'numero_contacto',
                        value: usuario.celular || usuario.telefono || ''
                    }
                });
            }
        }, [solicitud]);

    return (
        <Grid container spacing={3}>

            <Grid item xs={12}>
                <Paper elevation={0} style={{ padding: 15, backgroundColor: '#f9f9f9', borderLeft: `4px solid ${theme.palette.primary.main}`}}>
                    <Typography variant="caption" style={{ textAlign: 'justify', display: 'block' }}>
                        <strong>FASE 3: ACOMPAÑAMIENTO INTEGRAL - PEDAGÓGICO</strong><br />
                        Esta fase consiste en un espacio de acompañamiento integral y jurídico para el diálogo, la reflexión y la transformación de imaginarios colectivos, promoviendo una cultura de equidad.
                    </Typography>
                </Paper>
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    disabled
                    fullWidth
                    label="Nombre Completo"
                    name="nombre_completo"
                    value={safeValue('nombre_completo')}
                    onChange={onChange}
                    error={conError(safeError('nombre_completo'))}
                    helperText={safeError('nombre_completo')}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    disabled
                    fullWidth
                    label="No. de documento"
                    name="documento_identidad"
                    value={safeValue('documento_identidad')}
                    onChange={onChange}
                    error={conError(safeError('documento_identidad'))}
                    helperText={safeError('documento_identidad')}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    label="Lugar de expedición"
                    name="lugar_expedicion"
                    value={safeValue('lugar_expedicion')}
                    onChange={onChange}
                    error={conError(safeError('lugar_expedicion'))}
                    helperText={safeError('lugar_expedicion')}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    label="Número de contacto"
                    name="numero_contacto"
                    value={safeValue('numero_contacto')}
                    onChange={onChange}
                    error={conError(safeError('numero_contacto'))}
                    helperText={safeError('numero_contacto')}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    type="date"
                    label="Fecha"
                    name="fecha_registro"
                    InputLabelProps={{ shrink: true }}
                    value={safeValue('fecha_registro')}
                    onChange={onChange}
                    error={conError(safeError('fecha_registro'))}
                    helperText={safeError('fecha_registro')}
                />
            </Grid>
        </Grid>
    );
}

/* =======================
    STEP 2 — Medidas y Remisión
   ======================= */
function MedidasAcompanamiento({ state, onChange }) {
    const { safeValue, safeError, conError } = useFormValidation(state);

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <TextField
                    fullWidth
                    multiline
                    rows={6}
                    variant="outlined"
                    label="Medidas preventivas a tomar"
                    name="medidas_preventivas"
                    placeholder="Describa las medidas preventivas acordadas..."
                    value={safeValue('medidas_preventivas')}
                    onChange={onChange}
                    error={conError(safeError('medidas_preventivas'))}
                    helperText={safeError('medidas_preventivas')}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    select
                    fullWidth
                    label="¿Remisión para proceso conciliatorio?"
                    name="remision_conciliacion"
                    value={safeValue('remision_conciliacion')}
                    onChange={onChange}
                    error={conError(safeError('remision_conciliacion'))}
                    helperText={safeError('remision_conciliacion')}
                >
                    <MenuItem value="NO">No</MenuItem>
                    <MenuItem value="SI">Sí</MenuItem>
                </TextField>
            </Grid>

            {safeValue('remision_conciliacion') === 'SI' && (
                <Grid item xs={12}>
                    <Paper elevation={0} style={{ padding: 10, backgroundColor: '#fff3e0', marginBottom: 15 }}>
                        <Typography variant="caption">
                            <strong>Nota:</strong> Al ser afirmativo, por favor diligencie los compromisos del acuerdo a continuación.
                        </Typography>
                    </Paper>
                    <TextField
                        fullWidth
                        multiline
                        rows={6}
                        variant="outlined"
                        label="Compromisos adquiridos en el marco del acuerdo"
                        name="compromisos_acuerdo"
                        value={safeValue('compromisos_acuerdo')}
                        onChange={onChange}
                        error={conError(safeError('compromisos_acuerdo'))}
                        helperText={safeError('compromisos_acuerdo')}
                    />
                </Grid>
            )}
        </Grid>
    );
}


export const Formulario006Steps = [
    {
        label: 'Datos de Identificación',
        render: (props) => <DatosGenerales {...props} />
    },
    {
        label: 'Medidas y Acuerdos',
        render: (props) => <MedidasAcompanamiento {...props} />
    }
];